import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { User } from '@serasa/core/modules/users/interfaces/user.interface';
import { ListingComponent } from '@serasa/core/modules/dashboard/components/listing/listing.component';

import { Utils } from '../utils/utils';
import { UserProfileEnum } from '../enums/user-profile.enum';

@Directive({
    selector: '[appCheckPermissionToDeleteUser]',
    standalone: false
})
/**
 * Directive that checks the permission to delete a user.
 * 
 * @remarks
 * This directive verifies if the user has the permission to delete another user based on the following conditions:
 * 1. Check if it is the same logged-in user.
 * 2. Check if the logged-in user has the permission to delete the user (MANAGER or VC).
 * 
 * @example
 * ```html
 * <div *appCheckPermissionToDeleteUser="{ user: currentUser }">
 *   <!-- Content to be displayed if the user has permission to delete -->
 * </div>
 * ```
 */
export class CheckPermissionToDeleteUserDirective implements OnInit {

  @Input() appCheckPermissionToDeleteUser!: {
    user: User;
  };

  constructor(
    private readonly templateRef: TemplateRef<ListingComponent>,
    private readonly viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    if (this.appCheckPermissionToDeleteUser?.user) {
        const isSameUser = this._isSameUser(this.appCheckPermissionToDeleteUser.user);

        if (isSameUser) {
            this.viewContainer.clear();
        } else {
          const hasPermission = Utils.verifyUserProfile() !== UserProfileEnum.USER;
          if (hasPermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          }
        }
    }
  }


  private _isSameUser(user: Partial<User>): boolean {
    const userLogon = Utils.decodeToken(Utils.getCookie("accessToken"));
    return userLogon?.logon === user.logon;
  }  

}
